export default __webpack_public_path__ + "static/media/dropdown-arrow-down.80cbd02e.svg";